const scene = "syllabus/";
export const UPDATE_SYLLABUS = `${scene}UPDATE_SYLLABUS`;
export const UPDATE_PROGRESS = `${scene}UPDATE_PROGRESS`;
